/* WARNING: This file is auto-generated . Do not edit manually. */

export type CloudProjectDataProcessingNotebookNotebookEnv = {
  engineName?: string | null;
  engineVersion?: string | null;
};
